import { render, staticRenderFns } from "./SwitchFrameIcon.vue?vue&type=template&id=1b825bd6&"
import script from "./SwitchFrameIcon.vue?vue&type=script&lang=js&"
export * from "./SwitchFrameIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports